import Loadable from 'UIComponents/decorators/Loadable';
const AsyncProsemirrorRTE = Loadable({
  loader: () => import( /* webpackChunkName: "prosemirror-rte" */'./ProsemirrorRichTextEditor')
});
export default AsyncProsemirrorRTE;